<template>
  <div>
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
      <el-card header="基础信息" shadow="naver">
          <el-form-item label="活动封面">
            <div class="frm-tips">只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）</div>
            <div>
              <imgBox :imgUrl="wximageurl + form.ad_pic" inline @click="handleImgChange"></imgBox>
            </div>
            <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
          </el-form-item>
          <el-form-item label="活动名称" prop="activity_name" :rules="{required: true, message: '活动名称必填', trigger: 'blur'}">
            <el-col :span="20">
              <el-input v-model="form.activity_name" :maxlength=30 placeholder="活动名称"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="预告时间" prop="activity_release_time">
            <el-col :span="20">
              <el-date-picker
                v-model="form.activity_release_time"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="活动时间">
            <el-col :span="20">
              <el-date-picker
                v-model="activity_date"
                type="datetimerange"
                range-separator="至"
                start-placeholder="生效时间"
                end-placeholder="过期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="活动描述">
            <el-col :span="20">
              <el-input type="textarea" :rows="2" v-model="form.description" placeholder=""></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="是否返佣">
            <el-col :span="20">
              <!-- <el-radio v-model="form.is_activity_rebate" label="true" disabled="true">返佣</el-radio> -->
              <el-radio v-model="form.is_activity_rebate" label="false">不返佣</el-radio>
            </el-col>
          </el-form-item>
          <el-form-item label="是否包邮">
            <el-col :span="20">
              <el-radio v-model="form.is_free_shipping" label="true">包邮</el-radio>
              <el-radio v-model="form.is_free_shipping" label="false">商品自身运费模板</el-radio>
            </el-col>
          </el-form-item>
          <el-form-item label="订单取消" prop="validity_period">
            <el-row :gutter="10">
              <el-col :span="2">客户下单</el-col>
              <el-col :span="2">
                <el-input v-model="form.validity_period" placeholder="15" width="10"></el-input>
              </el-col>
              <el-col :span="12">分钟后未支付的订单，将自动取消</el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="活动商品类型">
            <el-radio v-model="form.item_type" label="normal" >实体类商品</el-radio>
            <!-- <el-radio v-model="form.item_type" label="services">服务类商品</el-radio> -->
          </el-form-item>
      </el-card>
      <el-card header="绑定商品" shadow="naver">
        <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
      </el-card>
      <el-card header="设置商品" shadow="naver">
        <el-table v-if="form.items.length>0" :data="form.items" style="line-height: normal">
          <el-table-column label="ID" prop="item_id" width="60"></el-table-column>
          <el-table-column label="货号" prop="item_bn" width="80"></el-table-column>
          <el-table-column label="名称" prop="item_title"></el-table-column>
          <el-table-column label="类型" prop="special_type">
            <template slot-scope="scope">
              <span style="color:red" v-if="scope.row.special_type == 'drug'" >处方药</span>
              <span style="color:blue" v-else>非处方药</span>
            </template>
          </el-table-column>
          <el-table-column label="活动价" width="100">
            <template slot-scope="scope">
                <el-input v-model="scope.row.activity_price" min="0.01" size="mini">
                  </el-input>
            </template>
          </el-table-column>
          <el-table-column label="库存" width="90">
            <template slot-scope="scope">
                <el-input v-model="scope.row.activity_store" width="90" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="每人限购" width="80">
            <template slot-scope="scope">
                <el-input v-model="scope.row.limit_num" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="排序" width="80">
            <template slot-scope="scope">
                <el-input v-model="scope.row.sort" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <i class="iconfont icon-trash-alt" @click="deleteItemRow(scope.$index, form.items)"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!-- 指定门店 start -->
      <el-card header="店铺" shadow="naver">
        <el-form-item label="适用店铺">
          <el-radio-group v-model="form.use_all_shops" @change="shopTypeChange">
            <el-radio label="true">全部适用</el-radio>
            <el-radio label="false">指定店铺适用</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="!zdShopHidden">
          <el-button type="primary" @click="addDistributorAction">选择店铺</el-button>
          <el-table v-if="distributor_info.length > 0" :data="distributor_info" style="line-height: normal">
            <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="50">
              <template slot-scope="scope">
                <i class="iconfont icon-trash-alt" @click="deleteDistritutorRow(scope.$index, form.items)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- 指定门店 end -->
      <div class="content-center">
        <el-button @click.native="handleCancel">返回</el-button>

        <el-button type="primary" @click="submitActivityAction()" v-if="this.copy_flag"> 复制活动 </el-button>
        <el-button type="primary" @click="submitActivityAction()" v-else> 保存 </el-button>

      </div>
    </el-form>
    <!-- 指定门店 start -->
    <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-shop-ids="relShopIds" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect>
    <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :rel-shop-ids="relDistributorIds" :get-status="setDistributorStatus" @chooseStore="chooseDistributorAction" @closeStoreDialog="closeDistributorDialogAction"></DistributorSelect>
    <!-- 指定门店 end -->
  </div>
</template>

<script>
import { seckillActivityCreate, seckillActivityGetInfo, seckillActivityUpdate } from '../../../../api/promotions'
import { getDefaultCurrency } from '../../../../api/company'
import SkuSelector from '@/components/function/skuSelector'
import imgPicker from '@/components/imageselect'
import imgBox from '@/components/element/imgBox'
// 指定门店 -- start --
import store from '@/store'
import StoreSelect from '@/components/storeselect'
import DistributorSelect from '@/components/storeListSelect'
// 指定门店 -- end --
export default {
  inject: ['refresh'],
  components:{
    SkuSelector,
    imgPicker,
    imgBox,
    // 指定门店 -- start --
    StoreSelect,
    DistributorSelect
    // 指定门店 -- end --
  },
  data () {
    return {
      cursymbol: '￥',
      goodsVisible: false,
      community: '1',
      communityList: [],
      communitycount: 0,
      relItems: [],
      addedItems: [],
      // 指定门店 -- start --
      distributorVisible: false, // 分销商可见，默认false
      setDistributorStatus: false,
      rel_shops_ids:[], // 指定适用门店ID集合
      distributor_info: [], // 指定适用门店信息集合
      relShopIds: '',
      relDistributorIds: '',
      is_distributor: false,
      zdShopHidden: true,
      setStatus: false,
      storeVisible: false,
      // 指定门店 -- end --
      communityParams: {
        page: 1,
        pageSize: 10,
        status: 'open',
      },
      copy_flag: false,
      form: {
        seckill_id: '',
        activity_name: '',
        description: '',
        activity_start_time: '',
        activity_end_time: '',
        activity_release_time: '',
        validity_period: 15,
        is_free_shipping: 'false',
        is_activity_rebate: 'false',
        items: [],
        ad_pic: '',
        item_type: 'normal',
        // 指定门店 -- start --
        use_all_shops: 'true', // 默认全部门店适用
        rel_shops_ids:[], // 指定适用门店ID集合
        distributor_id: [], // 指定门店信息集合
        // 指定门店 -- end --
      },
      activity_date: '',
      relItemsIds: [],
      selectItemType: 'normal',
      itemVisible: false,
      setItemStatus: false,
      imgDialog: false,
      isGetImage: false,
    }
  },
  methods:{
    getItems(data) {
      let arr = []
      data.forEach((item, index) => {
        let newData = ''
        let isInArr = this.addedItems.findIndex((n) => n.item_id == item.itemId)
        if (isInArr == -1) {
          newData = {
            item_id: item.itemId,
            item_bn: item.itemBn,
            item_title: item.itemName,
            // 默认设置活动库存 9999
            activity_store: 9999, // item.store,
            special_type: item.special_type,
            activity_price: item.price/100,
            item_spec_desc: item.item_spec_desc,
            sort: item.sort,
            limit_num: 1,
            item_type: item.item_type
          }
        } else {
          newData = this.addedItems[index]
        }
        arr.push(newData)
      })
      this.form.items = arr
    },
    handleImgChange () {
      this.imgDialog = true
      this.isGetImage = true
    },
    pickImg (data) {
      this.form.ad_pic = data.url
      this.imgDialog = false
    },
    closeImgDialog () {
      this.imgDialog = false
    },
    communityChange(val){
      if (val == 1) {
        this.form.community = []
      }
    },
    deleteItemRow: function (index, rows) {
      rows.splice(index, 1)
      this.form.items = rows
      this.setItemStatus = false
      this.relItemsIds.splice(index, 1)
    },
    submitActivityAction () {
      const that = this
      if (this.activity_date.length > 0) {
        this.form.activity_start_time = this.activity_date[0]
        this.form.activity_end_time = this.activity_date[1]
      }
      // 指定门店 -- start --
      if (this.form.use_all_shops === 'false' && !this.form.rel_shops_ids) {
        this.$message.error('请添加适用门店')
        return
      }
      // 指定门店 -- end --
      let params = JSON.stringify(this.form)
      params = JSON.parse(params)
      params.items = JSON.stringify(params.items)
      if (this.form.seckill_id) {
        seckillActivityUpdate(params).then(res => {
          if(res.data.data.seckill_id){
            this.loading = false
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      } else {
        seckillActivityCreate(params).then(res => {
          if(res.data.data.seckill_id){
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      }
    },
    // 指定门店 -- start --
    shopTypeChange (val) {
      this.zdShopHidden = true
      if (val === "false") {
        this.zdShopHidden = false
      } else {
        this.form.distributor_id = []
      }
    },
    addDistributorAction () {
      this.distributorVisible = true
      this.setDistributorStatus = true
      this.relDistributorIds = this.form.distributor_id
    },
    chooseStoreAction (data) {
      this.storeVisible = false
      this.form.rel_shops_ids = []
      if (data === null || data.length <= 0) return
      this.rel_shops_ids = data
      for (var i = 0; i < data.length; i++) {
        if(this.form.rel_shops_ids.indexOf(data[i].wxShopId) < 0) {
          this.form.rel_shops_ids.push(Number(data[i].wxShopId))
        }
      }
    },
    chooseDistributorAction (data) {
      this.distributorVisible = false
      this.distributorVisible = false
      if (data === null || data.length <= 0) return
      this.distributor_info = data
      for (var i = 0; i < data.length; i++) {
        if(this.form.distributor_id.indexOf(Number(data[i].distributor_id)) < 0) {
          this.form.distributor_id.push(Number(data[i].distributor_id))
        }
      }
    },
    closeStoreDialogAction () {
      this.storeVisible = false
    },
    closeDistributorDialogAction () {
      this.distributorVisible = false
    },
    deleteDistritutorRow (index) {
      this.distributor_info.splice(index, 1)
      let shopDatas = this.distributor_info
      this.form.distributor_id = []; // 重新初始化 distributor_id 为空数组
      for (var i = 0; i < shopDatas.length; i++) {
        if(this.form.distributor_id.indexOf(Number(shopDatas[i].distributor_id)) < 0) {
          this.form.distributor_id.push(Number(shopDatas[i].distributor_id))
        }
      }
    },
    // 指定门店 -- end --
    getTaskTime (strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y+"-"+m+"-"+d
        return str
    },
    getActivityDetail(id) {
      seckillActivityGetInfo({seckill_id:id}).then(res => {
        let response = res.data.data
        let distributor_id = []
        this.distributor_info = response.distributor_info
        for (var i in this.distributor_info) {
          if(distributor_id.indexOf(Number(this.distributor_info[i].distributor_id)) < 0) {
            distributor_id.push(Number(this.distributor_info[i].distributor_id))
          }
        }
        console.log(distributor_id);
        let data = {
          // 复制活动提交去掉秒杀id
          seckill_id:  this.copy_flag ? '' : response.seckill_id,
          activity_name: response.activity_name,
          description: response.description,
          activity_start_time: response.activity_start_time,
          activity_end_time: response.activity_end_time,
          activity_release_time: response.activity_release_date,
          validity_period: response.validity_period,
          is_free_shipping: response.is_free_shipping,
          is_activity_rebate: response.is_activity_rebate,
          items: '',
          ad_pic: response.ad_pic,
          item_type: response.item_type,
          use_all_shops: response.use_all_shops,
          distributor_info: response.distributor_info,
          distributor_id: distributor_id,
        }
        Object.assign(this.form, data)
        if (this.form.use_all_shops === "false") {
          this.zdShopHidden = false
        }
        this.addedItems = response.items
        this.activity_date = [response.activity_start_date, response.activity_end_date]
        this.relItems = response.itemTreeLists || []
        console.log(this.relItems)
      })
    },
    handleCancel: function () {
      this.$router.go(-1)
    }
  },
  mounted () {
    if (this.$route.query.seckill_id) {
      this.getActivityDetail(this.$route.query.seckill_id)
    }
    // 复制秒杀活动
    if (this.$route.query.copy_seckill_id) {
      this.getActivityDetail(this.$route.query.copy_seckill_id)
      this.copy_flag = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?2da3d54c